export enum routes {
	main = '/',
	list = '/list'
}
